<!--
 * @Author: your name
 * @Date: 2020-05-05 16:37:51
 * @LastEditTime: 2020-05-05 19:44:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /vue-basic-ui/packages/table/src/table.vue
 -->
<template>
  <div>
    <el-table
      :data="tableData"
      stripe
      style="width: 100%">
      <el-table-column
        v-for="(item,index) in columns"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'zyTable',
  props: {
    tableData: {
      type: Array,
      default: () => {
        return []
      }
    },
    columns: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {

    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// packages/table/src/table.vue